<template>
  <span class="truncate">{{ title || synopsis || "-" }}</span>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    synopsis: {
      type: String,
      required: true
    }
  }
}
</script>
